module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("\n    " + _vm._s(_vm.isworking ? _vm.workingtitle : _vm.restingtitle) + "\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7ba8d567!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/StateTitleComponent.vue
// module id = 52
// module chunks = 2